export const extractYouTubeId = (url: string) => {
  const match =
    /(?:https?:\/\/)?(?:www\.|m\.)?youtu(?:be)?\.(?:com|be)(?:\/watch\/?\?v=|\/embed\/|\/)([^\s&?/#]+)/.exec(
      url
    );

  return match ? match[1] : undefined;
};
